import React from 'react';

export default function FooterHome() {
  return (
    <div className='mt-16px text-262626'>
      <p className='font-roboto-medium text-14px leading-16px'>
        Copyright © 2021 Tổng Công ty Bảo Việt Nhân thọ
      </p>
      <p className='mt-7px text-12px leading-14px'>
        Trụ sở chính: Tầng 37, Keangnam Hanoi Landmark Tower, khu E6 khu đô thị mới Cầu Giấy, Phường
        Yên Hòa, Thành phố Hà Nội, Việt Nam
      </p>
    </div>
  );
}
